import { createFileRoute } from "@tanstack/react-router";
import { LayoutHeader } from "@/Header";
// import { Controller } from "react-hook-form";
// import { ValidateSelectList } from "@/SelectList";
// import { ValidateControllerSelect } from "@/ControllerSelect";
import ReservationChgClass from "@/customer/reservationChg/ReservationChgClass";
import ReservationChgDaycare from "@/customer/reservationChg/ReservationChgDaycare";
import ReservationChgHotel from "@/customer/reservationChg/ReservationChgHotel";
import ReservationChgBeauty from "@/customer/reservationChg/ReservationChgBeauty";
// import { useProductList } from "~/services/reservation";
import { usePet } from "^/common/usePet";
// import { useEffect } from "react";

interface ReservationParams {
  cdReservStatus?: string;
  cdReservType?: string;
  reservationSeq?: string;
  companySeq?: string;
  reservationDetailSeq?: number;
  companyName?: string;
}

export const Route = createFileRoute(
  "/customer/layout/calendar-reservation-chg"
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): ReservationParams => {
    return {
      cdReservStatus: search.cdReservStatus as string | undefined,
      cdReservType: search.cdReservType as string | undefined,
      reservationSeq: search.reservationSeq as string | undefined,
      companySeq: search.companySeq as string | undefined,
      reservationDetailSeq: search.reservationDetailSeq as number | undefined,
      companyName: search.companyName as string | undefined,
    };
  },
});

function RouteComponent() {
  const {
    cdReservStatus,
    cdReservType,
    reservationSeq,
    companySeq,
    reservationDetailSeq,
    companyName,
  } = Route.useSearch();
  console.log(
    cdReservStatus,
    cdReservType,
    reservationSeq,
    companySeq,
    reservationDetailSeq
  );
  console.log("RESERV_TYPE_KINDERGARTEN", cdReservType);
  // const { data: productTypeList } = useProductList(parseInt(companySeq || "0"));
  const { usePetList } = usePet();
  const { data: petList } = usePetList();

  return (
    <div>
      <>
        <LayoutHeader title={"예약"} hasBackBtn hasFootPrint={false} />
        <div className="flex flex-col flex-auto">
          <div className="flex-col flex-auto gap-1 px-5 pt-5 bg-[#F5F5F5] grid grid-cols-1">
            <div className="">
              {/* 업체명·예약 유형 카드는 각 ReservationChg* 컴포넌트 내부의
                  "이용 업체" 섹션으로 이관 (Class에 우선 적용, 그 외 타입은 추후 동일 디자인 적용 예정) */}
              {cdReservType === "RESERV_TYPE_CLASS" && (
                <ReservationChgClass
                  storeName={companyName || ""}
                  storeType={cdReservType}
                  storeData={{
                    value: companySeq || "",
                    label: companyName || "",
                  }}
                  petList={petList}
                  initialReservationSeq={
                    reservationSeq ? parseInt(reservationSeq) : undefined
                  }
                />
              )}
              {cdReservType === "RESERV_TYPE_DAYCARE" && (
                <ReservationChgDaycare
                  storeName={companyName || ""}
                  storeType={cdReservType}
                  storeData={{
                    value: companySeq || "",
                    label: companyName || "",
                  }}
                  petList={petList}
                  initialReservationSeq={
                    reservationSeq ? parseInt(reservationSeq) : undefined
                  }
                />
              )}
              {cdReservType === "RESERV_TYPE_HOTEL" && (
                <ReservationChgHotel
                  storeName={companyName || ""}
                  storeType={cdReservType}
                  storeData={{
                    value: companySeq || "",
                    label: companyName || "",
                  }}
                  petList={petList}
                  initialReservationSeq={
                    reservationSeq ? parseInt(reservationSeq) : undefined
                  }
                />
              )}
              {cdReservType === "RESERV_TYPE_GROOMING" && (
                <ReservationChgBeauty
                  storeName={companyName || ""}
                  storeType={cdReservType}
                  storeData={{
                    value: companySeq || "",
                    label: companyName || "",
                  }}
                  petList={petList}
                  initialReservationSeq={
                    reservationSeq ? parseInt(reservationSeq) : undefined
                  }
                />
              )}
            </div>
          </div>
        </div>
      </>
    </div>
  );
}
